import { forwardRef } from "react";

const InputTextAreaModal = forwardRef(
    ({ label, name, onChange, value, disabled = false, placeholder }, ref) => (
        <div className="mt-5 sm:mt-6">
            <label
                htmlFor={name}
                className="block text-sm font-medium text-left text-gray-700"
            >
                {label}
            </label>
            <div className="relative inline-block w-full text-left">
                <textarea
                    ref={ref}
                    rows={5}
                    cols={10}
                    name={name}
                    onChange={onChange}
                    value={value !== null ? value : ""}
                    disabled={disabled}
                    placeholder={placeholder}
                    className="inline-flex justify-between w-full px-3 py-2 overflow-auto text-sm font-normal text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm resize-y hover:bg-gray-50 focus:outline-none focus:ring-0"
                />
            </div>
        </div>
    )
);

export default InputTextAreaModal;
